import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import * as admin from "firebase-admin";

@Injectable()
export class AuthService {

    private currentUser: firebase.User;

    public error: any;
    public AuthUsername;
    // login show data user header 
    public email: any;
    public photo: any;
    public username: any;
    constructor(public afAuth: AngularFireAuth, public router: Router, public afdb: AngularFireDatabase) {
        // Get data user logged
        this.afAuth.authState.subscribe((res) => {
            if (res) {
                sessionStorage.setItem('dataUser', JSON.stringify(res))
            }
        })
        if (sessionStorage.getItem('dataUser') != null) {
            let DataUser;
            DataUser = JSON.parse(sessionStorage.getItem("dataUser"));
            this.username = DataUser.displayName
            this.email = DataUser.email
            this.photo = DataUser.photoURL

        } else {
            this.afAuth.authState.subscribe((res) => {
                if (res) {
                    this.username = res.displayName
                    this.email = res.email
                    this.photo = res.photoURL
                }
            })
        }
    }
    updateDataUser(dataItem,uid) {
        
        let dataUpdateTmp;
        let dataUser = this.afdb.list('/user');
        dataUser.subscribe((snap) => {
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].uid == uid){
                    dataUpdateTmp = snap[i]
                }
            }
        })
        let data = {
            uid: uid,
            address: dataItem
        }
        dataUser.update(dataUpdateTmp, data)
    }
    addDataUser(address) {
        let dataUser = this.afdb.list('/user');
        this.afAuth.authState.subscribe(res => {
            dataUser.push({
                uid: res.uid,
                address: address
            })
        })
    }
    getUserData() {
        return this.afdb.list('/user');
    }
    // Start listing users from the beginning, 1000 at a time.
    getLogin() {
        return this.afAuth.authState.map(res => {
            if (res) {
                return res.toJSON()
            }
        })
    }

    getUser() {
        return this.afdb.list('/member')
    }
    // Function Login Facebook 
    loginFb() {
        let index: boolean = false;
        this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()).then(
            (res) => {
                this.router.navigate([''])
            }).catch((err) => {
                this.error = err
            })
    }

    // Function Create Email password 
    singUp(email, password) {
        this.afAuth.auth.createUserWithEmailAndPassword(email, password).then((res) => {
            let createUser = this.afdb.list(`user`)
            this.router.navigate([''])
        }).catch((error) => {

        })
    }

    // Function Login Email password 
    loginEmailpassword(email, password) {
        this.afAuth.auth.signInWithEmailAndPassword(email, password).then((success) => {
            localStorage.clear();
            this.router.navigate([''])
        }).catch((err) => {
            this.error = err
        })
    }

    // Function Logout
    logout() {
        this.afAuth.auth.signOut().then((success) => {
            sessionStorage.removeItem('dataUser')
            this.router.navigate([''])
        }).catch((err) => {
            this.error = err
        });
    }
    saveData(data) {
        let pushData = this.afdb.list('/member')
    }
    getemail(): string {
        let email;
        this.afAuth.authState.map((snap) => {
            email = snap.email
        })
        return email
    }

}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/AuthService.ts